module.exports = __webpack_public_path__ + "img/grad.00ae2ec1.jpg";